export type Provider = {
  name: string;
  weight: number;
  scripts: string[];
  selector: string;
  timeout: number;
};

export const providers: Provider[] = [
  {
    name: 'nemedia',
    weight: 20,
    scripts: ['https://ru.viadata.store/tag/load.js?sid=105806'],
    selector: '[data-vads-ui-element]',
    timeout: 12000,
  },
  {
    name: 'adplay',
    weight: 5,
    scripts: ['https://widget.adplay.ru/fn/launch2283359.js'],
    selector: '[data-ad-player]',
    timeout: 10000,
  },
  {
    name: 'moe_video',
    weight: 75,
    scripts: ['https://cdn1.moe.video/p/cr.js'],
    selector: '#mv-slot',
    timeout: 10000,
  }
];

const moeVideoOptionsDesktop = {
  width: '100%',
  placement: 11719,
  promo: true,
  advertCount: 50,
  slot: 'page',
  sound: 'onclick',
  deviceMode: 'desktop',
  background: 'matte',
  fly: {
    mode: 'stick',
    width: 445,
    closeSecOffset: 5,
    position: 'bottom-right',
    indent: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    positionMobile: 'bottom',
  },
};

const moeVideoOptionsMobile = {
  width: '100%',
  placement: 11719,
  promo: true,
  advertCount: 50,
  slot: 'page',
  sound: 'onclick',
  deviceMode: 'mobile',
  background: 'matte',
  fly: {
    mode: 'stick',
    width: 445,
    closeSecOffset: 5,
    position: 'bottom-right',
    indent: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    positionMobile: 'bottom',
  },
};


export function providerOrder(random = Math.random): Provider[] {
  const remaining = [...providers];
  const ordered: Provider[] = [];
  while (remaining.length) {
    let weight = random() * remaining.reduce((sum, item) => sum + item.weight, 0);
    const index = remaining.findIndex((item) => (weight -= item.weight) < 0);
    ordered.push(...remaining.splice(index < 0 ? remaining.length - 1 : index, 1));
  }
  return ordered;
}
export function videoOptions(mobile: boolean) {
  return mobile ? moeVideoOptionsMobile : moeVideoOptionsDesktop;
}
